import { INVALID_EMAIL_MESSAGE, REQUIRED_FEILD, STRONG_PASSWORD_MESSAGE } from 'configs/constants';

export { PASSWORD_REGEX } from 'configs/regex';
// export { ROOT } from 'configs/routeNames';
// FIXME: find the use of these below 3 constants
export const LOGIN_PAGE = 'LOGIN';
export const FORGOT_PASSWORD_PAGE = 'FORGOT_PASSWORD_PAGE';
export const RESET_PASSWORD_PAGE = 'RESET_PASSWORD_PAGE';

export const validateMessages: IValidateMessages = {
  required: REQUIRED_FEILD,
  types: {
    email: INVALID_EMAIL_MESSAGE,
    password: STRONG_PASSWORD_MESSAGE,
  },
};

interface FormLayout {
  labelCol?: {
    span: number;
  };
  wrapperCol?: {
    span: number;
    offset?: number;
  };
}

export const layout: FormLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 12,
  },
};

export const tailLayout: FormLayout = {
  wrapperCol: {
    offset: 4,
    span: 12,
  },
};

interface LoginFieldsError {
  email: string;
  password: string;
}
interface IValidateMessages {
  required: string;
  types: LoginFieldsError;
}

export const backToLoginUrl = '/login';

export const OTP_TIME = 60 * 1;

export const defaultFormatPattern = 'XX.XXX.XXX/XXXX-XX';
export const defaultRegularExpression = '(^\\d{2}.\\d{3}.\\d{3}/\\d{4}-\\d{2}$)';
export const MAX_COMPANY_LOGO_COUNT = 1;

// Preload critical assets
export const preloadAssets = (loginBannerUrl: string) => {
  // Create a low-quality placeholder for the background
  const placeholder = new Image();
  placeholder.src =
    'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx4eHRoaHSQrJyEkKSM4Mjc1NjM4PTEwPDUxOC87VS43Pj89XmdaZFpvd3B3cI+Jn5n/2wBDARUXFx4aHh8fHx+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5//wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k=';

  // Add preload link for the background image
  const preloadLink = document.createElement('link');
  preloadLink.rel = 'preload';
  preloadLink.as = 'image';
  preloadLink.href = loginBannerUrl;
  preloadLink.setAttribute('fetchpriority', 'high');
  document.head.appendChild(preloadLink);

  // Add preconnect for Microsoft auth
  const preconnectLink = document.createElement('link');
  preconnectLink.rel = 'preconnect';
  preconnectLink.href = 'https://login.microsoftonline.com';
  document.head.appendChild(preconnectLink);
};

export enum PERMISSIONS_SUBJECTS {
  AGENCY = 'Agency',
  TRAVEL_AGENTS = 'Travel Agents',
  BANNERS = 'Banners',
  CUSTOMERS = 'Customers',
  FEEDBACK = 'Feedback',
  FINANCIALS = 'Financials',
  TRAVELERS = 'Travelers',
  REPORTS = 'Reports',
  TRIPS = 'Trips',
}
